import { render, staticRenderFns } from "./FilterDragIcon.vue?vue&type=template&id=b368b012"
import script from "./FilterDragIcon.vue?vue&type=script&lang=js"
export * from "./FilterDragIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports